// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"8a4daa94","459":"eb553a11","553":"5215a9be","684":"6a851f76","851":"91efdb03","881":"b6682fb9","961":"0525d8b7","983":"f0afa2db"}[chunkId] + ".chunk.js";
};